import translationsEn from "virtual:ember-intl/translations/en";
import translationsSv from "virtual:ember-intl/translations/sv";
import translationsFi from "virtual:ember-intl/translations/fi";

export function initialize(appInstance) {
  let intl = appInstance.lookup("service:intl");
  let storage = appInstance.lookup("service:storage");
  let locale = storage.get("glesys:locale") || "en";

  intl.addTranslations("en", translationsEn);
  intl.addTranslations("sv", translationsSv);
  intl.addTranslations("fi", translationsFi);

  intl.setLocale(locale);

  intl.setOnMissingTranslation(intl.onMissingTranslation);
}

export default {
  name: "locale",
  initialize,
};
